import React from 'react';

const Guide = () => {
    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', color: '#1f2937', fontFamily: 'system-ui, -apple-system, sans-serif' }}>

            {/* The Main Content Card */}
            <div style={{ 
                maxWidth: '800px', 
                margin: '40px auto', 
                padding: '40px', 
                backgroundColor: '#ffffff', 
                borderRadius: '12px', 
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                lineHeight: '1.7'
            }}>
                <h1 style={{ color: '#2563eb', borderBottom: '2px solid #e5e7eb', paddingBottom: '15px', marginTop: '0' }}>
                    Welcome to Tournament Master! 🏆
                </h1>
                
                <p style={{ fontSize: '1.1rem', color: '#4b5563', marginBottom: '30px' }}>
                    Tournament Master is your all-in-one platform for generating brackets, managing group stages, and tracking match scores.
                </p>
                
                <h2 style={{ color: '#1f2937', marginTop: '30px' }}>1. Getting Started</h2>
                <ul style={{ color: '#4b5563', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '10px' }}><strong>Create an Account:</strong> Click "Register" and enter a valid email address.</li>
                    <li style={{ marginBottom: '10px' }}><strong>Verify Your Identity:</strong> Check your inbox (and spam folder) for a verification link.</li>
                    <li style={{ marginBottom: '10px' }}><strong>Log In:</strong> Use your credentials to access the tournament dashboard.</li>
                </ul>

                <h2 style={{ color: '#1f2937', marginTop: '30px' }}>2. Creating a Tournament</h2>
                <ul style={{ color: '#4b5563', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '10px' }}>Navigate to the "New Tournament" page.</li>
                    <li style={{ marginBottom: '10px' }}>Give your tournament a name and select your format (e.g., Group Stage, Knockout).</li>
                    <li style={{ marginBottom: '10px' }}>Add your players or teams. Ensure all names are spelled correctly before generating the bracket!</li>
                    <li style={{ marginBottom: '10px' }}>Click <strong style={{ color: '#2563eb' }}>Generate</strong> to officially start the tournament.</li>
                </ul>

                <h2 style={{ color: '#1f2937', marginTop: '30px' }}>3. Submitting Scores</h2>
                <p style={{ color: '#4b5563' }}>
                    As matches are played, tournament admins can click on a specific matchup to enter the final score. Once submitted, our engine automatically calculates points, updates the leaderboard, and advances the winners.
                </p>

                <h2 style={{ color: '#1f2937', marginTop: '30px' }}>4. Found a bug?</h2>
                <p style={{ color: '#4b5563' }}>
                    This application is currently in Beta. If a button doesn't work or a score calculates incorrectly, please let us know so we can fix it!
                </p>
            </div>
        </div>
    );
};

export default Guide;